import { effect, inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MaintenanceService } from '../../modules/maintenance/service/maintenance.service';
import { MaintenanceState } from '../../modules/maintenance/enum/maintenance-state.enum';

@Injectable({ providedIn: 'root' })
export class MaintenanceAlertService {
  
  private readonly router = inject(Router);
  private readonly maintenanceService = inject(MaintenanceService);
  
  constructor() {
    effect(() => {
      const isMaintenance = this.maintenanceService.maintenanceState() === MaintenanceState.ACTIVE;
      const currentUrl = this.router.url;
      
      if (isMaintenance) {
        this.router.navigate(['/maintenance']);
      } else if (currentUrl === '/maintenance') {
        this.router.navigate(['/private/dashboard']);
      }
    });
  }
}
